// Color palette and configuration constants
export const colors = {
  searchSystemFill: '#f7a600',
  searchSystemStroke: '#000000',
  searchSystemStrokeWidth: '1px',
  searchSystemFillLowLiquid: '#fcb6b6',
  searchSystemFillLiquid: '#ff0000',
  searchSystemFillLowGaseous: '#a2defc',
  searchSystemFillGaseous: '#009eed',
  searchSystemFillLowMineral: '#cefab9',
  searchSystemFillMineral: '#3fbf00',
  systemFill: '#f7a600',
  systemStroke: '#000000',
  pathStroke: '#f7a600',
  pathStrokeWidth: '2px',
  resetSystemFill: '#cccccc',
  resetSystemStroke: '#000000',
  resetSystemFillOpacity: 0.8,
  resetSystemStrokeWidth: '1px',
  resetPathStroke: '#6e7980',
  resetPathStrokeWidth: '1px',
  gatewayLineColor: '#aa639eff',
  
  // Tol Palette (Vibrant/Muted mix for distinctness)
  tol: {
    navy: '#332288',
    green: '#117733',
    teal: '#44AA99',
    lightBlue: '#88CCEE',
    sand: '#DDCC77',
    rose: '#CC6677',
    purple: '#AA4499',
    wine: '#882255'
  },
  
  // Gateway Distance Mapping
  gateway: {
    under10: '#117733', // Green
    under15: '#44AA99', // Teal
    under20: '#DDCC77', // Sand
    under25: '#CC6677', // Rose
    over25: '#882255'   // Wine
  }
};